import React from 'react';
import styled from '@emotion/styled';
import { isDarkMode } from '../../../../../utils/helpers';
import { getAmountButtonTheme } from 'style';
import { FONT_FAMILIES } from 'theme/material/constants';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ButtonContainer = styled('div')(() => ({
  padding: 10,
  background: getAmountButtonTheme().backgroundStyle,
  borderRadius: 5,
  width: 131,
  border: getAmountButtonTheme().borderStyle,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
  marginLeft: 24,
  marginRight: 24,
  display: 'flex',
  justingContent: 'center',
  textAlign: 'center',
  alignItems: 'center',
}));

const ButtonCounterContainer = styled('div')({
  display: 'flex',
  justingContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
  width: '100%',
  gap: 10,
});

const ButtonLabelSuggest = styled('span')({
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: '-0.28px',
  lineHeight: '17px',
  color: getAmountButtonTheme().color,
  padding: 10,
});

const ButtonLabelOfferPrice = styled('span')(() => ({
  fontFamily: FONT_FAMILIES.secondary,
  fontSize: 32,
  fontWeight: 400,
  letterSpacing: '-0.3px',
  lineHeight: '30px',
  color: getAmountButtonTheme().color,
}));

const ButtonLabelCounter = styled('span')(() => ({
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: '-0.3px',
  lineHeight: '15px',
  color: isDarkMode() ? '#AFB0B1' : '#8F8F8F',
}));

interface IProps {
  onClick: () => void;
  variant: 'suggest' | 'counter';
  offerPrice: string;
  currencySymbols: any;
}
const OneTapSwipeOfferSuggestOrCounterButton: React.FC<IProps> = ({
  onClick,
  offerPrice,
  variant,
  currencySymbols,
}: IProps) => {
  const renderLabels = () => {
    switch (variant) {
      case 'suggest':
        return <ButtonLabelSuggest>Asked You to Suggest an Amount</ButtonLabelSuggest>;
      case 'counter':
        return (
          <ButtonCounterContainer>
            <ButtonLabelOfferPrice>
              {currencySymbols.currencyInitial}
              {currencySymbols.currencyLabel}
              {offerPrice}
            </ButtonLabelOfferPrice>
            <ButtonLabelCounter>Counter this Offer?</ButtonLabelCounter>
          </ButtonCounterContainer>
        );
      default:
        return <></>;
    }
  };

  return <ButtonContainer onClick={onClick}>{renderLabels()}</ButtonContainer>;
};

export default OneTapSwipeOfferSuggestOrCounterButton;
